<template>
  <div>
    <b-row>
      <b-col>
        <b-row
          class="content-header"
        >
          <b-col
            class="content-header-left mb-2"
            cols="12"
            md="9"
          >
            <b-row class="breadcrumbs-top">
              <b-col cols="12">
                <h2 class="content-header-title float-left pr-1 mb-0">
                  Pembayaran
                </h2>
                <div class="breadcrumb-wrapper">
                  <b-breadcrumb>
                    <b-breadcrumb-item
                      :to="{ name: 'dashboard-mechtech' }"
                    >
                      <feather-icon
                        icon="HomeIcon"
                        size="16"
                        class="align-text-top"
                      />
                    </b-breadcrumb-item>
                    <b-breadcrumb-item
                      :to="{ name: 'subscriptions' }"
                    >
                      Subscriptions
                    </b-breadcrumb-item>
                    <b-breadcrumb-item
                      :active="true"
                    >
                      Pembayaran
                    </b-breadcrumb-item>
                  </b-breadcrumb>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8">
        <b-card class="rounded-lg">
          <b-card-body>
            <b-row>
              <b-col>
                <h3>Detail Pembelian</h3>
                <span>Berikut adalah daftar langganan yang akan Anda beli</span>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-table striped :items="items" :fields="fields" class="shadow">
                  <template #cell(harga)="data">
                    {{ formatToRupiah(data.item.harga) }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col md="6">
                <b-row>
                  <b-col>
                    <span>Punya kode promo?</span>
                  </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col md="8">
                    <b-form-input
                      id="promotion-code"
                      v-model="promotionCode"
                      name="promotionCode"
                      placeholder="Masukkan kode promo"
                    />
                  </b-col>
                  <b-col md="4">
                    <b-button variant="primary">Gunakan</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card class="rounded-lg">
          <b-card-body>
            <b-row>
              <b-col>
                <h3>Pembayaran</h3>
                <span>Berikut adalah jumlah yang harus dibayarkan</span>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <span>Subtotal:</span>
              </b-col>
              <b-col class="text-right">
                <h4>{{ formatToRupiah(summary.subTotal) }}</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span>Diskon:</span>
              </b-col>
              <b-col class="text-right">
                <h4>- {{ formatToRupiah(summary.discountTotal) }}</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <span>Total:</span>
              </b-col>
              <b-col class="text-right">
                <h4>{{ formatToRupiah(finalTotal) }}</h4>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b-button variant="success" block>
                  PEMBAYARAN
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: ['item', 'harga'],
      items: [
        { item: 'Langganan 1 Bulan', harga: 250000 },
      ],
      summary: {
        subTotal: 250000,
        discountTotal: 0,
      },
      promotionCode: '',
    }
  },
  computed: {
    finalTotal () {
      return this.summary.subTotal - this.summary.discountTotal
    }
  },
  methods: {
    formatToRupiah(value) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });

      return formatter.format(value);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

  h2 {
    font-size: 1.25rem;

    @include media-breakpoint-up(sm) {
      font-size: 1.25rem;
    }
    @include media-breakpoint-up(md) {
      font-size: 1.75rem;
    }
    @include media-breakpoint-up(lg) {
      font-size: 1.75rem;
    }
    @include media-breakpoint-up(xl) {
      font-size: 1.75rem;
    }
  }

</style>
